@for (group of groupedResults; track group.detailsQuery.value) {
  <app-list-group
    [label]="group.name"
    [count]="group.count || null"
    [expanded]="!!group.isOpened"
    (expandedChange)="onGroupToggle(group, $event)"
  >
    @if (group.isLoading) {
      <app-spinner message="" [small]="true" />
    }
    @if (!group.isLoading && group.items.length === 0 && group.isOpened) {
      <p class="empty-group">No results</p>
    }
    @for (item of group.items; track item._id) {
      <app-list-item
        [selected]="selectedItem?._id === item._id"
        [selectable]="canSelect"
        [hasMenu]="true"
        [checked]="isItemChecked(item)"
        (checkedChange)="onItemCheckedChange(item, $event)"
        (click)="selectItem(item); $event.stopPropagation()"
      >
        <span itemTitle>{{ getDisplayName(item) }}</span>
        <ng-container itemMenu>
          <button mat-menu-item (click)="deleteItem(item)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
        </ng-container>
      </app-list-item>
    }
  </app-list-group>
}
